<div class="page-layout carded fullwidth">
    <mat-drawer-container class="overlay-container" autosize style="height: 100vh; overflow: auto;">

    <filtros-auditorias [(filtro)]="filterForm" (loadData)="loadData()" (filterChange)="filterForm=$event"></filtros-auditorias>
    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Pistas de Auditoría</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR
            <div class="toolbar px-24 py-8">
                <span>Escenarios</span>
            </div>-->
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" fxFlex="100" fxLayout="column">

              <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8">
                <!-- User Column -->
                <ng-container matColumnDef="actividad">
                  <th mat-header-cell *matHeaderCellDef> Actividad </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.actividad}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="usuario">
                  <th mat-header-cell *matHeaderCellDef> Usuario </th>
                  <td mat-cell *matCellDef="let element"> {{element.usuario?.nombreCompleto}} </td>
                </ng-container>

                <ng-container matColumnDef="perfil">
                  <th mat-header-cell *matHeaderCellDef> Perfil </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list aria-label="Perfiles">
                      <mat-chip *ngFor="let tipo of element.perfiles">{{tipo.nombre}}</mat-chip>
                    </mat-chip-list>
                  </td>
                </ng-container>

                <ng-container matColumnDef="fecha">
                  <th mat-header-cell *matHeaderCellDef> Fecha </th>
                  <td mat-cell *matCellDef="let element"> {{element.fecha | date:'dd/MM/yyyy HH:mm'}} </td>
                </ng-container>

                <ng-container matColumnDef="tipo">
                  <th mat-header-cell *matHeaderCellDef> Tipo </th>
                  <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

                <mat-paginator #paginator [length]="elementCount" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="basicSlice"
                               (page)="OnePageChange($event)" showFirstLastButtons fxFlex="100"></mat-paginator>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->
    </div>

  </mat-drawer-container>
</div>
